<template>
  <div class="scroll">
    <!--导航菜单-->
    <div class="nav" :class="actAnchor ? 'navAnchor' : ''">
      <Row justify="center" type="flex" style="width: 100%; height: 84px">
        <Col :xs="2" :sm="2" :md="2" :lg="4" :xl="4">
          <img
            style="height: 27px; margin: 9% 0px 0px -2%"
            src="../../static/img/home/logo.png"
            alt="公司logo"
          />
        </Col>
        <Col :xs="0" :sm="0" :md="0" :lg="6" :xl="10">
          <div class="menu_div">
            <Menu
              mode="horizontal"
              :theme="menuTheme"
              :active-name="$route.name"
              @on-select="onMenuSelect"
            >
              <Menu-Item
                name="contentWisdomSite"
                to="/home/content/contentWisdomSite"
              >
                首页
              </Menu-Item>
              <Submenu name="Buy">
                <template slot="title"> 企业产品</template>
                <div style="max-height: 50vh">
                  <Menu-Item name="SafetyEducation" to="/home/Buy/WisdomSite">
                    VR/MR体验区
                  </Menu-Item>
                  <Menu-Item name="SafetyEducation" to="/home/Buy/Projection">
                    智慧消防
                  </Menu-Item>
                  <Menu-Item name="SafetyEducation" to="/home/Buy/Quality">
                    智能展示区
                  </Menu-Item>
                </div>
              </Submenu>
              <Menu-Item name="Enterprise" to="/home/enterPrise">
                企业资质
              </Menu-Item>
              <Submenu name="News">
                <template slot="title">
                  <router-link to="/home/News" style="color: #222"
                    >企业新闻</router-link
                  >
                </template>
                <Menu-Item name="NewsProfile" to="/home/News"
                  >行业新闻
                </Menu-Item>
              </Submenu>
              <Submenu name="AboutUs">
                <template slot="title">
                  <router-link to="/home/AboutUs" style="color: #222"
                    >关于我们</router-link
                  >
                </template>
                <Menu-Item name="CompanyProfile" to="/home/AboutUs"
                  >公司简介
                </Menu-Item>
              </Submenu>
              <Menu-Item name="ContactUs" to="/home/ContactUs"
                >联系我们
              </Menu-Item>
            </Menu>
            <!-- <ul class="top_ul">
              <li>首页</li>
              <li>企业产品</li>
              <li>关于我们</li>
              <li>企业资质</li>
              <li>企业新闻</li>
              <li>联系我们</li>
            </ul> -->
          </div>
        </Col>
        <Col
          :xs="{ span: 2, offset: 20 }"
          :sm="{ span: 2, offset: 20 }"
          :md="{ span: 2, offset: 20 }"
          :lg="0"
          :xl="0"
        >
          <img
            @click="drawerValue = true"
            style="margin-top: 15px; width: 48px; height: 48px"
            src="../../static/img/home/liebiao1.png"
            alt="暂无照片"
          />
        </Col>
      </Row>
    </div>
    <!--打开抽屉,里面是移动端的导航菜单-->
    <Drawer v-model="drawerValue" width="50" placement="left" :closable="false">
      <div class="DrawerMenu">
        <Menu
          width="100"
          :theme="menuTheme"
          :active-name="$route.name"
          :open-names="['Buy', 'AboutUs', 'News']"
          @on-select="onMenuSelect"
        >
          <Menu-Item name="Content" to="/home/content/contentWisdomSite">
            首页
          </Menu-Item>
          <Submenu name="Buy">
            <template slot="title"> 企业产品</template>
            <div style="max-height: 50vh">
              <Menu-Item name="SafetyEducation" to="/home/Buy/WisdomSite">
                VR体验区
              </Menu-Item>
              <Menu-Item name="SafetyEducation" to="/home/Buy/Projection">
                智慧消防
              </Menu-Item>
              <Menu-Item name="SafetyEducation" to="/home/Buy/Resiliometer">
                智能展示区
              </Menu-Item>
            </div>
          </Submenu>
          <Submenu name="AboutUs">
            <template slot="title"> 关于我们</template>
            <Menu-Item name="CompanyProfile" to="/home/AboutUs"
              >公司简介
            </Menu-Item>
          </Submenu>
          <Menu-Item name="Enterprise" to="/home/enterPrise">
            企业资质
          </Menu-Item>
          <Submenu name="News">
            <template slot="title"> 企业新闻</template>
            <Menu-Item name="NewsProfile" to="/home/News">行业新闻</Menu-Item>
          </Submenu>
          <Menu-Item name="ContactUs" to="/home/ContactUs">联系我们</Menu-Item>
        </Menu>
      </div>
    </Drawer>
    <!--导航点击过后显示的页面-->
    <router-view></router-view>
    <!--底部-->
    <Row type="flex" justify="center" class="bot-col">
      <Col :sm="0" :xs="0" :md="0" :lg="24" :xl="24">
        <Row type="flex" justify="center">
          <!-- <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ name: 'Resiliometer' }"
                  >企业产品
                </router-link>
              </p>
              <ul>
                <li>
                  <router-link :to="{ name: 'VR' }">VR安全体验区</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Quality' }"
                    >工法质量样板展示区
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Resiliometer' }"
                    >智能测量工具
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'SafetyEducation' }"
                    >安全教育
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Interaction' }"
                    >互动电子沙盘
                  </router-link>
                </li>
              </ul>
            </div>
          </Col> -->
          <!-- <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ name: 'CompanyProfile' }"
                  >关于我们
                </router-link>
              </p>
              <ul>
                <li>
                  <router-link :to="{ name: 'CompanyProfile' }"
                    >公司简介
                  </router-link>
                </li>
              </ul>
            </div>
          </Col>
          <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ name: 'Enterprise' }">企业资质</router-link>
              </p>
            </div>
          </Col>
          <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ name: 'NewsProfile' }"
                  >新闻资讯
                </router-link>
              </p>
              <ul>
                <li>
                  <router-link :to="{ name: 'NewsProfile' }"
                    >行业新闻
                  </router-link>
                </li>
              </ul>
            </div>
          </Col> -->
          <Col
            :xs="{ span: 18, offset: 4 }"
            :lg="{ span: 6, offset: 1 }"
            :xl="{ span: 6, offset: 1 }"
            style="margin-top: 20px; display: flex"
          >
            <div class="weixin">
              <div class="wei_ding">
                <img src="../../static/img/home/wei_guan.jpg" alt="#" />
                <div style="color: #ffffff">微信公众号</div>
              </div>
            </div>
            <div class="date">
              <div class="date1">周一到周五:09:00-21:00</div>
              <div class="date2">周六到周日:00:00-24:00</div>
              <div style="color: #fff; font-size: 16px">
                客服热线：400-9667895
                <br />
                0371-55113808
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col :sm="24" :xs="24" :md="24" :lg="0" :xl="0" style="margin: 0px">
        <Row type="flex" justify="center">
          <Col :sm="8" :xs="8" :md="8" :lg="0" :xl="0" class="bot-col-col">
            <img
              style="width: 150px; height: 150px"
              src="../../static/img/home/wei_guan.jpg"
              alt="#"
            />
          </Col>
          <Col :sm="8" :xs="8" :md="8" :lg="0" :xl="0" class="bot-col-col">
            <img
              style="width: 150px; height: 150px"
              src="../../static/img/home/home_guanwang.png"
              alt="#"
            />
          </Col>
        </Row>
        <Row
          type="flex"
          justify="center"
          style="margin-top: 20px; line-height: 50px"
        >
          <Col
            :sm="22"
            :xs="22"
            :md="22"
            :lg="0"
            :xl="0"
            style="display: flex; place-items: center"
          >
            <img width="28px" src="../../static/img/home/adress.png" alt="#" />
            &nbsp;
            <span style="font-size: 24px; color: white"
              >地址：郑州市郑东新区龙子湖中原数据产业大厦7层</span
            >
          </Col>
          <Col
            :sm="22"
            :xs="22"
            :md="22"
            :lg="0"
            :xl="0"
            style="display: flex; place-items: center"
          >
            <img width="28px" src="../../static/img/home/phone.png" alt="#" />
            &nbsp;
            <span style="font-size: 24px; color: white"
              >客服热线：
              <a href="tel:400-9667895" style="font-size: 28px">400-9667895</a>
            </span>
          </Col>
          <Col
            :sm="22"
            :xs="22"
            :md="22"
            :lg="0"
            :xl="0"
            style="display: flex; place-items: center"
          >
            <img width="28px" src="../../static/img/home/phone.png" alt="#" />
            &nbsp;
            <span style="font-size: 24px; color: white">
              客服热线：<a href="tel:0371-55113808" style="font-size: 28px"
                >0371-55113808</a
              >
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
    <!--最底部-->
    <Row type="flex" justify="center" style="margin: 0 0 0 0">
      <Col
        :xs="24"
        :lg="24"
        :xl="24"
        style="background-color: #000; height: 62px"
      >
        <div class="top-ul-li1">
          <ul>
            <li>CopyRight&copy; 河南南秀数智科技有限公司</li>
            <li>地址：郑州市郑东新区龙子湖中原数据产业大厦7层</li>
            <li @click="localBei">备案号：豫ICP备17041859号-5</li>
          </ul>
        </div>
      </Col>
    </Row>
    <!--侧边栏-->
    <div class="outSide" v-show="sidebar">
      <div class="service" @click="ModalService">
        <div class="service-img">
          <img src="../../static/img/home/service03.png" alt="#" />
        </div>
        <div
          style="
            font-size: 12px;
            font-family: 'Microsoft YaHei', serif;
            color: #000;
          "
        >
          联系客服
        </div>
      </div>
      <div class="WeChat">
        <Poptip trigger="hover" placement="left">
          <div class="service-img">
            <img
              style="width: 32px; height: 32px"
              src="../../static/img/home/WeChat.png"
              alt="#"
            />
          </div>
          <div
            style="
              font-size: 12px;
              font-family: 'Microsoft YaHei', serif;
              color: #000;
            "
          >
            微信关注
          </div>
          <div slot="content">
            <img
              style="width: 128px; height: 128px"
              src="../../static/img/home/code.png"
              alt="#"
            />
          </div>
        </Poptip>
      </div>
      <div class="Weibo" @click="windowOpen">
        <div class="service-img">
          <img src="../../static/img/home/weibo.png" alt="#" />
        </div>
        <div
          style="
            font-size: 12px;
            font-family: 'Microsoft YaHei', serif;
            color: #000;
          "
        >
          官方微博
        </div>
      </div>
    </div>
    <!--返回顶部-->
    <BackTop
      :height="100"
      :bottom="50"
      style="background-color: #000"
    ></BackTop>
    <!--客服聊天-->
    <!-- <div class="chitchat" v-show="dialog">
      <div class="chit-top">
        <Icon
          type="ios-close"
          class="chit-icon"
          @click="getChitIcon"
          style="font-size: 28px; color: white; cursor: pointer"
        />
      </div>
      <div>
        <div class="talk_show">
          <div
            v-for="(i, index) in arr"
            :class="i.person === 'A' ? 'atalk' : 'btalk'"
            :key="index"
          >
            <span>{{ i.person }}说：{{ i.words }}</span>
          </div>
        </div>
        <div class="talk_input">
          <div>
            <label>
              <select class="whotalk" v-model="str1">
                <option value="0">A说：</option>
                <option value="1">B说：</option>
              </select>
            </label>
          </div>
          <div>
            <label>
              <textarea
                autofocus
                class="talk_word"
                @keyup.enter="add_data"
                name="text"
                placeholder="请输入您的问题"
                v-model="str2"
              >
              </textarea>
            </label>
          </div>
          <div class="talk_sub">
            <Button @click="add_data">发送</Button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      /*抽屉*/
      drawerValue: false,
      /*表单*/
      formItem: {
        userName: "",
        email: "",
        phone: "",
        message: "",
        code: "",
      },
      ruleItem: {},
      /*验证码*/
      show_num: [],
      /*-----*/
      dialog: false,
      actAnchor: false,
      menuTheme: "light",
      CarouselVal: 0,
      /*客服聊天*/
      arr: [
        { person: "A", words: "" },
        { person: "B", words: "" },
      ],
      str1: "0",
      str2: "",
      showImg: false,
      sidebar: false,
    };
  },
  mounted() {
    //监听滚动事件
    window.addEventListener("scroll", this.OnScroll, false);
  },
  destroyed() {
    //移除滚动事件
    window.removeEventListener("scroll", this.OnScroll);
  },
  methods: {
    /*跳转到工信备案网站*/
    localBei() {
      window.open("https://beian.miit.gov.cn");
    },
    /*跳转买商品*/
    getMoney(item) {
      console.log(item);
      this.$router.push({
        path: "/buyGo",
        query: {
          money: item.money,
          ref: item.ref,
          photoUrl1: item.photoUrl1,
        },
      });
    },
    /*打开微博*/
    windowOpen() {
      window.open("https://weibo.com/u/6004822810");
    },
    //*弹出客服聊天*/
    getChitIcon() {
      this.dialog = false;
    },
    /*聊天*/
    add_data() {
      // bug: 内容不能为空。
      if (this.str2.trim() === "") {
        this.$Message.info("内容不能为空");
        this.str2 = "";
        return;
      }
      var p = this.str1 === "0" ? "A" : "B";
      var obj = { person: p, words: this.str2 };
      this.arr.push(obj);
      // 添加完内容，清空
      this.str2 = "";
    },
    /*弹出对话框*/
    ModalService() {
      this.dialog = true;
    },
    /*滚动事件*/
    OnScroll() {
      let _this = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 90) {
        _this.actAnchor = scrollTop > 90;
        _this.showImg = true;
        _this.sidebar = true;
      } else {
        _this.actAnchor = scrollTop > 90;
        _this.showImg = false;
        _this.sidebar = false;
      }
    },
    /*导航菜单点击事件*/
    onMenuSelect() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.drawerValue = false;
    },
  },
};
</script>

<style scoped>
/*导航*/

.nav {
  width: 100%;
  background: white;
}

.menu_div {
  width: 850px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  margin-right: 10%;
}

.menu_div /deep/ .ivu-menu-horizontal.ivu-menu-light:after {
  height: 0;
}

.menu_div /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu i {
  display: none;
}

.menu_div /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.menu_div /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  font-size: 17px;
  color: #222;
  font-family: "微软雅黑", Arial, Helvetica, sans-serif, Microsoft Yahei;
}

/deep/ .ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-horizontal .ivu-menu-submenu {
  padding: 0px 30px;
}

/* /deep/ .ivu-col-span-xs-0 {
  margin-right: 16%;
} */

.menu_div
  .ivu-menu-horizontal
  .ivu-menu-submenu
  .ivu-select-dropdown
  .ivu-menu-item {
  font-size: 16px !important;
  line-height: 32px;
}

/*抽屉导航*/
.DrawerMenu /deep/ .ivu-menu-vertical.ivu-menu-light .ivu-menu-item,
.DrawerMenu /deep/ .ivu-menu-vertical.ivu-menu-light .ivu-menu-submenu {
  font-size: 20px;
}

.DrawerMenu /deep/ .ivu-menu-vertical.ivu-menu-light:after {
  height: 0;
}

/*------------导航吸顶-------------*/
.header {
  width: 100%;
  height: 90px;
  background: #eeeeee;
}

.navAnchor {
  position: fixed;
  top: 0;
  z-index: 999;
  border-bottom: 1px solid #ccc;
}

/*---------------------------*/

/*---------侧边栏----------*/
.outSide {
  width: 64px;
  height: 210px;
  background: #fff;
  color: white;
  font-family: "Microsoft YaHei", serif;
  font-size: 8px;
  position: fixed;
  _position: relative;
  right: 25px;
  top: 600px;
  z-index: 999;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}

.service {
  padding-top: 8px;
  width: 100%;
  height: 70px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}

.Weibo {
  padding-top: 8px;
  width: 100%;
  height: 70px;
  cursor: pointer;
}

.WeChat {
  width: 100%;
  height: 70px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.service div,
.WeChat div,
.Weibo div {
  text-align: center;
}

.WeChat:hover,
.service:hover,
.Weibo:hover {
  background: #02a0e7;
}

.service-img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.service img {
  width: 32px;
  height: 32px;
}

.Weibo img {
  width: 32px;
  height: 32px;
}

/*-----------------------------*/

/*--------------客服聊天----------------------*/
.chitchat {
  width: 400px;
  height: 500px;
  position: fixed;
  _position: relative;
  right: 14px;
  top: 420px;
  z-index: 9999;
  border-radius: 14px;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.16);
}

.chit-icon {
  position: absolute;
  top: 2px;
  right: 4px;
}

.chit-top {
  width: 400px;
  height: 60px;
  background: #02a0e7;
  border-radius: 14px 14px 0 0;
}

.talk_show {
  width: 400px;
  height: 350px;
  background: #fafdff;
  overflow: auto;
}

.talk_input {
  width: 400px;
  height: 100px;
  background: #dddddd;
  border-radius: 0 0 14px 14px;
  display: flex;
}

/*谁说话*/
.whotalk {
  width: 60px;
  height: 100px;
  outline: none;
  border-radius: 0 0 0 14px;
  border: none;
  background: #eeeeee;
}

/*询问问题*/
.talk_word {
  width: 260px;
  height: 100px;
  padding: 4px 0 0 0;
  outline: none;
  text-indent: 4px;
  resize: none;
  /*border-radius: 0 0 0 14px;*/
  border: none;
  color: #666666;
  font-family: "Microsoft YaHei", serif;
}

/*发送信息*/
.talk_sub {
  width: 80px;
  height: 100px;
  background: #eeeeee;
  padding: 36px 0 0 10px;
  border-radius: 0 0 14px 0;
}

.atalk {
  margin: 10px;
}

.atalk span {
  display: inline-block;
  background: #e7eeed;
  border-radius: 10px;
  color: black;
  padding: 5px 10px;
}

.btalk {
  margin: 10px;
  text-align: right;
}

.btalk span {
  display: inline-block;
  background: #02a0e7;
  border-radius: 10px;
  color: #fff;
  padding: 5px 10px;
}

/*--------------------------------------------*/
/*--------------底部--------------------------*/

@media screen and (max-width: 567px) {
  .top-ul-li1 ul li {
    font-size: 26px;
  }
}

.top-ul-li {
  margin: 20px 0 0 0;
  text-align: center;
}

.top-ul-li p {
  font-size: 16px;
  color: #fff;
  /* border-left: 1px solid #ffffff; */
}

.top-ul-li ul {
  color: #afaeb3;
  list-style-type: none;
  text-align: center;
  line-height: 23px;
  position: relative;
  top: 6px;
}

.top-ul-li a {
  color: white;
}

.top-ul-li ul li a {
  color: #afaeb3;
  font-size: 15px;
}

.top-ul-li ul li a:hover,
.top-ul-li1 ul li:hover {
  color: white;
  cursor: pointer;
}

.top-ul-li1 {
  width: 100%;
  height: 100%;
  /* margin: 20px 0 0 0; */
  text-align: center;
}

.top-ul-li1 ul {
  color: #afaeb3;
  list-style-type: none;
  line-height: 56px;
  position: relative;
  top: 6px;
}

.top-ul-li1 ul li {
  display: inline-block;
  padding: 0 5px;
  cursor: pointer;
}

.weixin {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 567px) {
  .top-ul-li ul {
    line-height: 96px;
  }

  .weixin {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.wei_ding {
  text-align: center;
  cursor: pointer;
}

.date {
  text-align: center;
  color: #e44d3d;
  margin: 20px 0 0 40px;
}

.date1:hover,
.date2:hover {
  color: red;
  cursor: pointer;
}

.bot-col {
  background-color: #000;
  margin-top: 150px;
}

.bot-col-col {
  display: grid;
  place-items: center;
  margin-top: 20px;
}

/*---------------------------------------------*/
/* a {
  color: #222;
} */

.top_ul li {
  float: left;
  padding-left: 60px;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue